"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const LayerFilled = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 15,
  height: 16,
  viewBox: "0 0 15 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.5 11.746l6.133-4.807L15 5.873 7.5 0 0 5.873 1.358 6.94 7.5 11.746zm0 2.131L1.35 9.07 0 10.127 7.5 16l7.5-5.873-1.358-1.066L7.5 13.877z",
  className: "fill"
}));

var _default = LayerFilled;
exports.default = _default;